import * as Yup from 'yup';
import {
    stringWithNoSpecialChars,
    validateTaskCategory,
    validateOptionalNumber,
} from "@/Shared/Helpers";
import { TaskEnums } from '@/Shared';


export type TaskFormValues = {
    id: number,
    category: string,
    label: string,
};

export const TaskValidationSchema = (viewEnums: TaskEnums) => Yup.object({

    id: validateOptionalNumber(),

    category: validateTaskCategory(viewEnums.TaskCategoryEnum),

    label : stringWithNoSpecialChars({ minLength: 10, maxLength: 500 }).required('Le label de la tâche est requis.'),
});
